<template>
  <div class="home">
    <img class="yui_bg-main" src="../../assets/bg-2.jpg" alt="">


    <!--    <van-notice-bar class="yui-notice-bar"-->
    <!--                    scrollable-->
    <!--                    :text="noticeBarText"/>-->
    <div class="yui_card-1">
      <label class="yui-input-box">
        <input class="yui-input"
               type="tel"
               name="phone"
               id="phoneInvite"
               v-model="phone"
               v-number-only
               maxlength="11"
               placeholder="请输入手机号">
      </label>
      <div class="yui-popup-form">
        <label class="y-input-box">
          <input class="yui-input"
                 type="tel"
                 ref="verifyCode"
                 id="verifyCode"
                 name="verifyCode"
                 maxlength="6"
                 v-model="verifyCode"
                 placeholder="验证码"
                 v-number-only>
        </label>

        <div class="yui-count-down">
          <van-count-down ref="countDown"
                          v-show="countDownStatus===1"
                          millisecond
                          :time="countDownTime"
                          :close-on-click-overlay="false"
                          :closeable="true"
                          :auto-start="false"
                          @finish="countDownFinish"
                          format="sss"/>
          <van-button v-show="countDownStatus===2"
                      type="primary"
                      size="mini"
                      plain
                      @click="resendPay"
                      color="#ff8d22"
                      class="yui-btn-reset"> 重新发送
          </van-button>
          <van-button v-show="countDownStatus===0"
                      type="primary"
                      size="mini"
                      @click="toSendCode"
                      color="#ff8d22"
                      class="yui-btn-reset"> 点击发送
          </van-button>
        </div>


      </div>
      <!--      <p class="yui-pop-desc">验证码已发送{{ codePhone|phoneFilter }}</p>-->
      <img src="../../assets/btn-invite-join.png"
           @click="toSaveInvitor"
           class="y_btn-invite"
           alt="">

      <!--
            <div class="yui_card-1_item">
              <h5>成功邀请</h5>
              <p>
                <span>{{ inviteNum }}</span> 人
              </p>
            </div>
            <div class="yui_card-1_item">
              <h5>累计获得</h5>
              <p>
                <span>{{ totalCoinNum }}</span> 个能量
              </p>
            </div>-->
    </div>


<!--    <img class="btn-download" @click="toUserWallet" src="../../assets/btn-download-2.png" alt="">-->
<!--    <img class="btn-toDetail"-->

<!--         src="../../assets/btn-invite-download.png"-->
<!--         @click="toUserWallet"-->
<!--         alt="点击查看详情">-->


<!--    <img class="btn-toExchangePrize"-->
<!--         src="../../assets/btn-toExchangePrize.png"-->
<!--         @click="toExChange"-->
<!--         alt="点击兑换奖品">-->


<!--    <img class="link-1"-->
<!--         src="../../assets/link-1.png"-->
<!--         @click="toLink1"-->
<!--         alt="">-->

    <div class="link-1"  @click="toLink1"></div>

    <div class="y_to-download" @click="toUserWallet">

    </div>

  </div>
</template>

<script>
// @ is an alias to /src
// import HelloWorld from '@/components/HelloWorld.vue'
import {
  addInviteInfo,
  postSendCode
} from "@/services/api";

export default {
  name: 'Invite',
  data() {
    return {
      noticeBarText: '技术是开发它的人的共同灵魂。地球是文明的摇篮。世界是存在于认知中的，灵魂是认知的集，认知来源于经历。',
      pageStatus: '',
      activityNo: 'COINCOIN7M',
      coinNum: 0,
      inviteNum: 0,
      totalCoinNum: 0,
      phone: '',
      inviteStatus: 0,

      codePhone: '',
      countDownTime: 60 * 1000,// 倒计时时长 60秒
      countDownStatus: 0,// 倒计时状态
      verifyCode: '',//验证码
      verifyCodeToast: '',
      verifyCodeAjaxStatus: false,// 获取验证码页面请求状态
    }
  },
  components: {
    // HelloWorld
  },
  directives: {
    numberOnly: {
      bind: function (el) {
        el.handler = function () {
          el.value = el.value.replace(/\D+/, '')
        }
        el.addEventListener('input', el.handler)
      },
      unbind: function (el) {
        el.removeEventListener('input', el.handler)
      },


    }
  },
  computed: {
    invitePhone() {
      return this.$route.query.uNo
    },
    phoneState() {
      return /^1[3456789]\d{9}$/.test(this.phone);
    }
  },
  filters: {
    phoneFilter: function (tel) {
      // var tel = 19812311111;
      tel = "" + tel;
      // d表示数字0-9,{3}表示需要3个，所以d{3}就是表示3个数字
      var reg = /(\d{3})\d{4}(\d{4})/;
      //$1是第一个小括号里的 ,$2是第2个小括号里的
      return tel.replace(reg, "$1****$2")

    }
  },
  mounted() {


  },
  methods: {
    toSaveInvitor() {
      let that = this
      if (this.phone === '') {
        this.$toast('手机号不可为空')
        return false;
      }
      if (!this.phoneState) {
        this.$toast('手机号格式错误')
        return false;
      }
      if (this.verifyCode === '') {
        this.$toast('验证码不可为空')
        return false;
      }
      if (this.codePhone === '') {
        this.$toast('请先获取验证码')
        return false;
      }
      let rObj = new FormData()
      rObj.append('mobileNo', this.invitePhone)
      rObj.append('inviteNo', this.phone)
      rObj.append('verifyCode',this.verifyCode)
      addInviteInfo(rObj).then(res => {
        if (res.respcod === '01') {
          that.inviteStatus = 1
          that.phone = ''
          that.verifyCode=''
          // that.onExchangeCodeObj.param = res.data.param
          // that.onExchangeCodeObj.productId = productId
          // that.dialogExchangePhoneBillShow = false
          this.$toast(res.respmsg)
        } else {
          this.$toast(res.respmsg)
        }
      }).catch(onerror => {
        console.error(onerror)
        this.$toast('网络错误')
      })
    },
    getPageInfo(token, deviceCoding) {
      let that = this
      this.$store.dispatch('handGetUserCoinInfo', {
        token,
        deviceCoding
      }).then(res => {
        console.log(res)
        that.coinNum = res.coinNum
        that.inviteNum = res.inviteNum
        that.totalCoinNum = res.totalCoinNum
      }).catch(err => {
        this.$toast(err)
        console.error(err)
      })
    },

    toUserWallet() {

      window.location.href = "http://www.bestugo.com/metro/download.html"

    },
    toExChange() {
      window.location.href = "http://www.bestugo.com/metro/download.html"
    },

    toLink1() {
      if (window._czc) {
        window._czc.push(['_trackEvent', '绿色能量6月', '建行生活', '分享页外链点击数', 1, '']);
      }
      window.location.href = "https://yunbusiness.ccb.com/gbchannel/e_report/outercoupon/#/CustomerActivity/20210223070000000255%20/ZF0002553522Q"
    },

    /**
     * 倒计时结束
     */
    countDownFinish() {
      this.$refs.countDown.reset();
      this.countDownStatus = 2
    },
    startCountDown() {
      let that = this
      that.countDownStatus = 1
      setTimeout(function () {
        that.$refs.countDown.start()
        that.$refs.verifyCode.focus()
      }, 0)
    },
    toSendCode() {
      let that = this
      if (this.phone === '') {
        this.$toast('手机号不可为空')
        return false;
      }
      if (!this.phoneState) {
        this.$toast('手机号格式错误')
        return false;
      }
      let rObj = new FormData()
      rObj.append('Id', 1)
      rObj.append('Phone', this.phone)
      rObj.append('Type', 1)
      postSendCode(rObj).then(res => {
        console.log(res)

        if (res.respcod === '01') {
          that.codePhone = res.data.Phone

          that.countDownStatus = 1
          setTimeout(function () {
            that.$refs.countDown.start()
            that.$refs.verifyCode.focus()
          }, 0)
        }

      })
    },

    resendPay() {
      this.countDownStatus = false
      this.toSendCode()
    },

  }
}
</script>
<style lang="less" scoped>
.home {
  background-color: #86cc8e;
}

.yui_bg-main {
  width: 100%;
  height: auto;
  display: block;

}

.yui_banner {
  position: relative;

  .yui_banner-img {
    width: 100%;
    display: block;
  }

  .yui_banner-btn {
    position: absolute;
    right: 0;
    top: 20vw;
    background-color: #dc5c2ae0;
    display: block;
    padding: 2vw 5vw;
    font-size: 4vw;
    color: #ffffff;
    border-top-left-radius: 5vw;
    border-bottom-left-radius: 5vw;
  }
}

.yui_art {
  padding: 20px;
  text-align: left;
  word-break: break-all;
}

.yui_footer {
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  padding: 5vw;

}

.yui-notice-bar {
  position: absolute;
  //width: 60vw;
  top: 92vw;
  left: 20vw;
  right: 20vw;
  font-size: 3vw;
  height: 6vw;
  border-radius: 2vw;
}


.yui_card-1 {
  position: absolute;
  top: 150vw;
  left: 12vw;
  right: 12vw;
  //background-color: #de7f1b50;
  //display: flex;
  //align-items: center;

  .yui_card-1_item {
    flex: 1;
    position: relative;

    h5 {
      margin: 0;
      font-size: 4vw;
      font-weight: 500;
    }

    p {
      margin: 0;
      line-height: 12vw;
      color: #eb1b00;
      font-size: 4vw;

      span {
        font-size: 8vw;

        //font-weight: 600;
      }
    }

    &:last-child:before {
      position: absolute;
      content: " ";
      top: 0;
      left: 0;
      bottom: 0;
      border-left: 1px solid #dfdfdf;
    }
  }
}

.btn-toDetail {
  position: absolute;
  top: 185vw;
  width: 42vw;
  left: 29vw;
  display: block;
}


.btn-toExchangePrize {
  position: absolute;
  top: 281vw;
  width: 44vw;
  left: 28vw;
  display: block;
}

.btn-invite {
  width: 70vw;
  margin: 0 auto;
}

.yui-fix-footer {
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  padding: 0 10vw 10vw;
  text-align: center;
}

.link-1 {
  position: absolute;
  top: 814vw;
  left: 7vw;
  width: 86vw;
  height: 23vw;
  display: block;
}

.yui-input-box {
  width: 70vw;
  display: block;
  margin-top: 2vw;
  margin-bottom: 2vw;
  margin-left: auto;
  margin-right: auto;

  .yui-input {
    max-width: 100%;
    border: none;
    font-size: 3.75vw;
    padding: 2vw 5vw;
    background-color: #F5F5F5 !important;
    border-radius: 2vw;
    height: 5vw;
    line-height: 3.75vw;
    width: 50vw;
    color: #595959 !important;
    text-align: center;

    &::placeholder {
      font-size: 3.75vw;
      line-height: 4vw;
      color: #b3b3b3;
    }

    &:disabled {
      opacity: 1 !important;
    }

    &:focus,
    &:hover {
      background-color: #ffffff70;
      color: #fad7c5;
    }
  }
}


.y_btn-invite {
  //position: absolute;
  //top: 30vw;
  margin: 4vw auto;
  display: block;
  width: 44vw;
  //left: 25vw;
}


.yui-popup-form {
  display: flex;
  align-items: center;
  width: 60vw;

  background-color: #f0f0f0;
  border-radius: 1vw;
  margin: 2vw auto;

  .y-input-box {
    flex: 1;
    padding: 2vw 3vw;

    //line-height: 12vw;

  }

  .yui-input {

    background-color: transparent;
    border: none;
    width: 100%;
    font-size: 4vw;
    color: #b3b3b3;
    line-height: 1!important;

    &::placeholder {
      //font-size: 4vw;
      line-height: 1.4em!important;
      color: #b3b3b3;
    }
  }

  .yui-count-down {
    min-width: 7vw;
    position: relative;
    padding: 0 3vw;
    font-size: 4vw;
    color: #b3b3b3;

    &:before {
      position: absolute;
      content: " ";
      left: 0;
      top: -1vw;
      bottom: -1vw;
      border-left: 0.3vw solid #d4d4d4;
    }
  }
}
.btn-download{
  position: absolute;

  top: 882vw;
  left: 20vw;
  width: 60vw;
  display: block;
}
.y_to-download{
  position: absolute;
display: block;
  left: 14vw;
  width: 72vw;
  height: 20vw;
  top: 926vw;
}
.yui-btn-reset{
  line-height: 1;
}
</style>
